import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ShieldCheck, BadgeCheck, FileCheck2, Lock } from "lucide-react";
import { cn } from "@/lib/utils";

export const TrustNote = ({ compact = false, className }) => {
  const { t } = useTranslation();
  const points = [[BadgeCheck, "p1"], [FileCheck2, "p2"], [Lock, "p3"]];
  return (
    <motion.section initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} data-testid="trust-note"
      className={cn("relative overflow-hidden rounded-3xl bg-[#0B192C] text-white z-noise", compact ? "p-5 md:p-6" : "p-7 md:p-12", className)}>
      <div className="pointer-events-none absolute -start-16 -top-16 h-56 w-56 rounded-full bg-[#06B6D4]/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -end-10 h-56 w-56 rounded-full bg-[#10B981]/20 blur-3xl" />
      <div className={cn("relative", !compact && "grid items-center gap-8 md:grid-cols-[auto_1fr]")}>
        <div className={cn("flex items-center gap-3", !compact && "md:flex-col md:items-start")}>
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-gradient-to-br from-[#06B6D4] to-[#10B981] shadow-[0_12px_30px_-10px_rgba(16,185,129,0.7)] md:h-14 md:w-14"><ShieldCheck size={26} /></span>
          <h2 className={cn("font-black leading-tight", compact ? "text-base md:text-lg" : "text-xl md:text-2xl")} data-testid="trust-note-title">{t("trust_note.title")}</h2>
        </div>
        <div>
          <p className={cn("leading-relaxed text-white/80", compact ? "mt-3 text-sm" : "text-base md:text-lg")} data-testid="trust-note-body">{t("trust_note.body")}</p>
          {!compact && (
            <ul className="mt-5 flex flex-wrap gap-2">
              {points.map(([I, k]) => <li key={k} className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-xs font-bold text-white/90 backdrop-blur"><I size={14} className="text-[#10B981]" />{t(`trust_note.${k}`)}</li>)}
            </ul>
          )}
          <p className={cn("font-black z-gradient-text", compact ? "mt-3 text-sm" : "mt-6 text-lg md:text-xl")} data-testid="trust-note-closing">{t("trust_note.closing")}</p>
        </div>
      </div>
    </motion.section>
  );
};
